import { notify } from './notify';

const patchedClients = new WeakSet();

let handler = null;
let lastEmitAt = 0;
const DEDupe_MS = 2800;

function normalizePath(url) {
  if (!url) return '';
  const withoutQuery = String(url).split('?')[0];
  if (withoutQuery.startsWith('http')) {
    try {
      return new URL(withoutQuery).pathname || '';
    } catch {
      return withoutQuery;
    }
  }
  return withoutQuery.replace(/^https?:\/\/[^/]+/, '');
}

function isCredentialAuthRequest(config) {
  const path = normalizePath(config?.url || '');
  const method = (config?.method || 'get').toLowerCase();
  if (path.includes('/api/auth/login') && method === 'post') return true;
  if (path.includes('/api/auth/guid/') && method === 'post') return true;
  return false;
}

export function shouldHandleSession401(error) {
  if (error?.response?.status !== 401) return false;
  if (error?.config?.skipGlobal401) return false;
  if (isCredentialAuthRequest(error.config)) return false;
  const code = error?.response?.data?.code;
  if (code === 'INVALID_CREDENTIALS') return false;
  return true;
}

function emitSessionExpired(payload) {
  const now = Date.now();
  if (now - lastEmitAt < DEDupe_MS) {
    return;
  }
  lastEmitAt = now;

  if (typeof handler === 'function') {
    try {
      handler(payload);
    } catch {
      /* avoid breaking axios chain */
    }
  } else {
    notify({
      title: 'Session ended',
      description:
        'Your session is no longer active. Please sign in again or reopen your access link.',
      status: 'warning',
    });
  }
}

/**
 * Register the in-app handler (navigate home, clear client auth). Call from a component under BrowserRouter.
 */
export function registerSessionExpiryHandler(next) {
  handler = typeof next === 'function' ? next : null;
}

export function attachSessionExpiryInterceptor(client) {
  if (!client?.interceptors || patchedClients.has(client)) return;
  patchedClients.add(client);

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (shouldHandleSession401(error)) {
        emitSessionExpired({ error });
        Object.assign(error, { rsworksSessionHandled: true });
      }
      return Promise.reject(error);
    }
  );
}
